export const getInitials = (firstName?: string, lastName?: string): string => {
  const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
  return `${firstInitial}${lastInitial}`;
};

export const formatDate = (dateString: Date | string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const capitalize = (str: string | null | undefined) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatPrice = (price: number) => {
  if (!price) return '0';
  return price.toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP',
  });
};

export const formatDateTime = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const truncateDescription = (description: string, maxLength: number) => {
  if (description.length <= maxLength) return description;
  return description.slice(0, maxLength) + '...';
};

export const cleanPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters including '+' and spaces
  console.log('Original phone number:', phoneNumber);
  const cleanedNumber = phoneNumber.replace(/\D/g, '');
  console.log('Cleaned phone number:', cleanedNumber);
  return cleanedNumber;
};

export const handleRutChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
) => {
  const input = e.target.value.toUpperCase();
  const numericInput = input.replace(/[^\dK]/g, '');
  let formattedRut = '';

  if (numericInput.length <= 1) {
    formattedRut = numericInput;
  } else {
    const body = numericInput.slice(0, -1);
    const dv = numericInput.slice(-1);
    formattedRut = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + dv;
  }

  handleInputChange({
    target: {
      name: 'rut',
      value: formattedRut,
    },
  } as React.ChangeEvent<HTMLInputElement>);
};

export const handlePhoneNumberChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
) => {
  let input = e.target.value.replace(/\D/g, '');
  
  // Asegurarse de que el número comience con 569
  if (!input.startsWith('569')) {
    input = '569' + input.slice(input.startsWith('56') ? 2 : 0);
  }
  
  // Limitar a 11 dígitos en total (incluyendo 569)
  input = input.slice(0, 11);
  
  // Formatear el número
  const formattedNumber = '+' + input;
  
  handleInputChange({
    target: {
      name: 'phoneNumber',
      value: formattedNumber,
    },
  } as React.ChangeEvent<HTMLInputElement>);
};
